export default __webpack_public_path__ + "static/media/terms.a21ad30e.svg";